<template>
  <div class="clearfix">
    <div
      class="reveal"
      ref="noPermModal"
      id="noPermModal"
      data-reveal
    >
      <div class="tender-confirm clearfix">
        <p class="confirm-header">{{ $t('warn.perms.title') }}</p>
        <p class="msg_hint">{{ $t('warn.perms.hint') }}</p>
        <div class="row align-center">
          <button
            id="confirm_ok"
            type="button"
            class="btn btn--orange"
            data-close
          >{{ $t('action.ok') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'

export default {
  name: 'NoPermModal',
  methods: {
    async init () {
      if (!this.noPermModal) {
        this.noPermModal = await new Foundation.Reveal($('#noPermModal'), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
    },
    async openModal () {
      await this.init()
      this.noPermModal.open()
    },
    closeModal () {
      if (this.noPermModal) {
        this.noPermModal.close()
      }
    },
  },

  mounted () {
    EventBus.$on('modules_no_perm_modal_open', () => {
      this.openModal()
    })
    EventBus.$on('modules_no_perm_modal_close', () => {
      this.closeModal()
    })
  },
  destroyed () {
    EventBus.$off('modules_no_perm_modal_open')
    EventBus.$off('modules_no_perm_modal_close')
    if (this.noPermModal) {
      this.noPermModal.destroy()
    }
    $('#noPermModal').remove()
  },
}
</script>

<style scoped lang="scss">
@import '~styles/settings';
@import '~styles/popup';

#noPermModal {
  width: 500px;
}
.align-center {
  padding-top: 15px;
}
</style>
